import { render, staticRenderFns } from "./ci_badge_link.vue?vue&type=template&id=5f874d1a&"
import script from "./ci_badge_link.vue?vue&type=script&lang=js&"
export * from "./ci_badge_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ci_badge_link.vue"
export default component.exports